var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plane",
    d: "M19.531,0a.481.481,0,0,1,.5.5v1a.481.481,0,0,1-.5.5h-19a.481.481,0,0,1-.5-.5V.5a.481.481,0,0,1,.5-.5ZM2.563-3.344.156-5.937a.555.555,0,0,1-.109-.469.526.526,0,0,1,.3-.406l1.25-.625a.555.555,0,0,1,.25-.062.555.555,0,0,1,.25.063l2.25,1.125,3.25-1.625L2.688-11a.548.548,0,0,1-.125-.5.569.569,0,0,1,.313-.406l2.031-1.031A.555.555,0,0,1,5.156-13a.506.506,0,0,1,.313.094l6.844,2.563,3.094-1.562a5.056,5.056,0,0,1,2.688-.594q1.438.094,1.813.859A2.051,2.051,0,0,1,19.5-9.656a5.131,5.131,0,0,1-2.094,1.813L8.313-3.219A2.068,2.068,0,0,1,7.375-3H3.313A.92.92,0,0,1,2.563-3.344Z",
    transform: "translate(-0.031 13)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.017689651922be62300e323c976e7b5d.svg";
export { ForwardRef as ReactComponent };